import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';

const TrustBanner = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-12 bg-secondary">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6">
          <div 
            className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-border rounded-full"
          >
            <Shield className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-foreground">
              {t('landing.trust.proofChip')}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
